export { default as CategoriesIndexTableBody } from './CategoriesIndexTableBody';
